
import { defineComponent } from 'vue'
// 导入 Vue Router 类型
import { RouteLocationRaw } from 'vue-router'
import { hasAppFeature } from '@/api/base'

// 定义Store状态接口
interface StoreState {
  state: {
    theme: string;
    collapse: boolean;
    project: {
      logo: string;
      logo_square: string;
    };
  }
}

export default defineComponent({
    props: ['active', 'list'],
    data () {
        return {
            menu: [
                {
                    name: '首页',
                    path: '/',
                    meta: {
                        title: '首页',
                        icon: 'el-icon-house',
                        icon2: ''
                    }
                },
                {
                    name: '保险方案',
                    path: '/insurance/plan',
                    meta: {
                        title: '保险方案',
                        icon: 'el-icon-document-add',
                        icon2: ''
                    }
                },
                {
                    name: '被派遣单位',
                    path: '/dispatch',
                    meta: {
                        title: '被派遣单位',
                        icon: 'el-icon-office-building',
                        icon2: ''
                    }
                },
                {
                    name: '员工查询',
                    path: '/workers',
                    meta: {
                        title: '员工查询',
                        icon: 'el-icon-user',
                        icon2: ''
                    }
                },
                {
                    name: '报案理赔',
                    path: '/report',
                    meta: {
                        title: '报案理赔',
                        icon: 'el-icon-help',
                        icon2: ''
                    }
                },
                {
                    name: '费用及发票',
                    meta: {
                        title: '费用及发票',
                        icon: 'el-icon-document',
                        icon2: ''
                    },
                    children: [
                        {
                            title: '账户充值',
                            path: '/recharge',
                            meta: {
                                title: '账户充值'
                            }
                        },
                        {
                            title: '充值记录',
                            path: '/recharge/record',
                            meta: {
                                title: '充值记录'
                            }
                        },
                        {
                            title: '发票记录',
                            path: '/invoice/record',
                            meta: {
                                title: '发票记录'
                            }
                        }
                    ]
                },
                {
                    name: '团队管理',
                    path: '/team',
                    meta: {
                        title: '团队管理',
                        icon: 'el-icon-suitcase',
                        icon2: ''
                    }
                }
            ]
        }
    },
    computed: {
        activeTextColor () {
            return getComputedStyle(document.documentElement).getPropertyValue('--nav-active-text-color').trim()
        },
        textColor () {
            return getComputedStyle(document.documentElement).getPropertyValue('--nav-text-color').trim()
        },
        backgroundColor () {
            return getComputedStyle(document.documentElement).getPropertyValue('--nav-background').trim()
        },
        getMenuIcon () {
            return (defaultIcon: string): string => {
                // 如果是橙色主题，返回不同的图标
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const $store = (this as any).$store
                if ($store.state.theme === 'orange') {
                    const iconMap: Record<string, string> = {
                        'el-icon-house': 'el-icon-s-home',
                        'el-icon-document-add': 'el-icon-s-order',
                        'el-icon-office-building': 'el-icon-s-shop',
                        'el-icon-user': 'el-icon-s-custom',
                        'el-icon-help': 'el-icon-s-claim',
                        'el-icon-document': 'el-icon-s-management',
                        'el-icon-suitcase': 'el-icon-s-cooperation'
                    }
                    return iconMap[defaultIcon] || defaultIcon
                }
                return defaultIcon
            }
        },
        getMenuTitle () {
            return (defaultTitle: string): string => {
                // 如果是橙色主题，返回不同的标题
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const $store = (this as any).$store
                if ($store.state.theme === 'orange') {
                    const titleMap: Record<string, string> = {
                        被派遣单位: '用工单位',
                        员工查询: '员工投保记录',
                        报案理赔: '出险报案'
                    }
                    return titleMap[defaultTitle] || defaultTitle
                }
                return defaultTitle
            }
        }
    },
    async created () {
        // const menu = await getMenu()
        // this.menu = menu
        // console.log(menu)
        if (hasAppFeature('wikiMenu')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const $store = (this as any).$store
            this.menu.push({
                name: '知识库',
                path: 'https://wiki.yuanqihu.com',
                meta: {
                    title: '知识库',
                    icon: $store.state.theme === 'orange' ? 'el-icon-collection' : 'el-icon-reading',
                    icon2: 'el-icon-link'
                }
            })
        }
    },
    methods: {
        goRouter (path: string) {
            // 判断path内是否包含http
            if (path.indexOf('http') > -1) {
                window.open(path)
            } else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const $router = (this as any).$router
                $router.push({
                    path
                })
            }
        }
    }
})
